// Module
var code = "<textarea name=\"document-notes\" id=\"document-notes\" placeholder=\"Notes...\"><%= notes %></textarea>";
// Exports
module.exports = code;